import type { PriceSegmentViewUnavailableReason } from '@/types'

export const PRICE_SEGMENTS_UNAVAILABLE_TEXTS: Record<
  PriceSegmentViewUnavailableReason,
  string | null
> = {
  CLIENT_USER: null,
  CONTEXT_SEGMENT_UNAVAILABLE:
    'Сегмент клиента неактивен: другие сегменты недоступны',
  NO_OTHER_SEGMENTS: 'Других сегментов для просмотра нет',
}

export const PROCUREMENT_PARTNER_HINT =
  'На складах партнёров цена — по сегменту, который назначил партнёр, выбор сегментов на неё не влияет'

export const CONTEXT_SEGMENT_NOTE = 'для корзины'

export const getMaxSelectableHint = (maxSelectable: number) =>
  `Можно выбрать не больше ${maxSelectable} сегментов`

export const getPartnerSegmentHint = (description: string) =>
  `Цена партнёра по его сегменту «${description}»`
